import { TranslateService } from '@ngx-translate/core';
import { Meta, Title } from '@angular/platform-browser';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromApp from '../../store/app.reducers';
import * as fromAuth from '../store/auth.reducers';
import * as AuthActions from '../store/auth.actions';
import { RememberPasswordService } from '../../core/header/dialogs/remember-password/remember-password.service';
import { BaseWebComponent } from '@web/base/shared/components/base-web/base-web.component';
import { SharedService } from '@web/base/shared/shared.service';
import { ConstantsProject } from '@web/project/shared/constants.class';
import { Constants } from '@web/base/shared/constants.class';
import { constants } from 'os';
import { SimpleSnackbarComponent } from '@web/base/shared/components/simple-snackbar/simple-snackbar.component';
import { IResponse } from '@web/base/shared/models/response.model';
import { CoreService } from '@web/base/core/core.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'web-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent extends BaseWebComponent implements OnInit {


  @ViewChild('password', { static: true }) password: ElementRef;

  public URLS_TYPES_PRODUCTS = Constants.URLS_TYPES_PRODUCTS;
  public URLS_TYPES_COURSES = Constants.URLS_TYPES_COURSES;
  public URLS_TYPES_CONTACTS = Constants.URLS_TYPES_CONTACTS;

  section = 'signin';
  textLink;
  typeLink;
  returnURL;

  breadcrumbs = [{ label: 'signin', url: '', navigable: false }];

  public form: UntypedFormGroup;
  public type: string;

  authState$: Observable<fromAuth.State>;

  constructor(
    private store: Store<fromApp.AppState>,
    public authService: AuthService,
    private rememberPasswordService: RememberPasswordService,
    public sharedService: SharedService,
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public meta: Meta,
    public title: Title,
    public coreService: CoreService,
    public snackbar: MatSnackBar) {
    super(translate, snackbar, null, meta, title, route, sharedService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.getTranslations(['core', 'signin']).then(() => {
      this.breadcrumbs[0].label = this.translations['signin']['title'];
      this.setBreadcrumbs();

      this.route.data.subscribe(d => {
        this.route.queryParams.subscribe(r => {
          if (d.section === 'login-by-hash') {
            this.authService.loginByHash(decodeURIComponent(r.email), r.hash).subscribe((res: IResponse) => {
              localStorage.setItem(ConstantsProject.TOKEN_KEY, res.result.token);
              this.coreService.loadTemplate();
              this.router.navigate(['home']);
            }, err => {
              const message =
                err.error && err.error.result && err.error.result.message
                  ? err.error.result.message
                  : 'error';

              this.openSnackbar(message, SimpleSnackbarComponent.TYPE_ERROR);
            });

          } else {

            this.returnURL = r.returnUrl;
            if (r.returnUrl.indexOf(Constants.URLS_TYPES_PRODUCTS) !== -1) {
              this.textLink = this.translations['signin']['textRegister'];
              this.typeLink = Constants.URLS_TYPES_PRODUCTS;
            } else {
              if (r.returnUrl[0].indexOf(Constants.URLS_TYPES_COURSES) !== -1 || r.returnUrl.indexOf(Constants.URLS_TYPES_COURSES) !== -1) {
                this.textLink = this.translations['signin']['textRegister'];
                this.typeLink = Constants.URLS_TYPES_COURSES;
              } else {
                if (r.returnUrl.indexOf(Constants.URLS_TYPES_CONTACTS) !== -1) {
                  this.textLink = this.translations['signin']['textSubscription'];
                  this.typeLink = Constants.URLS_TYPES_CONTACTS;
                } else {
                  this.textLink = '';
                  this.typeLink = null;
                }
              }
            }
          }
        });
      });
    });

    if (this.typeLink === null) {
      this.authState$ = this.store.select('auth');
    }

    this.form = new UntypedFormGroup({
      username: new UntypedFormControl(null, Validators.compose([
        Validators.required,
        Validators.minLength(1), Validators.maxLength(120)
      ])),
      password: new UntypedFormControl(null, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(60)]))
    });
  }

  login() {
    if (this.form.valid) {
      this.store.dispatch(new AuthActions.TrySignin(this.form.value));
    }
  }

  openRememberPasswordDialog(type: string) {
    // this.dialogRef.close();
    this.rememberPasswordService.openDialog(type);
  }

  showPass() {
    this.password.nativeElement.type = 'text';
  }

  hidePass() {
    this.password.nativeElement.type = 'password';
  }

  link() {
    switch (this.typeLink) {
      case Constants.URLS_TYPES_PRODUCTS:
        this.router.navigate(['usuarios', 'registro'], { queryParams: { returnUrl: this.returnURL } });
        break;
      case Constants.URLS_TYPES_COURSES:
        this.router.navigate(['usuarios', 'registro'], { queryParams: { returnUrl: this.returnURL } });
        break;
      case Constants.URLS_TYPES_CONTACTS:
        this.router.navigate(['informacion', 'suscripciones']);
        break;
    }
  }

}
